import { Paper } from "@material-ui/core";
import MaterialTable from "material-table";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";
import Select from "react-select";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import {
  ErrorUnexpected,
  OperationSuccessfully,
} from "../../../../const/Messages";
import * as DraNextIndexCustomService from "../../../../service/DraNextIndexCustomService";
import * as PlmnService from "../../../../service/PlmnService";

/**
  @author Guilherme Almeida
  @date 08/01/2025
 */
export default function DraNextIndexCustom() {
  const [list, setList] = useState([]);
  const [plmnList, setPlmnList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    PlmnService.findComboBox()
      .then((list) =>
        setPlmnList(
          list.reduce((acc, item) => {
            acc[item.id] = item.name;
            return acc;
          }, {})
        )
      )
      .catch(() => toast.error(ErrorUnexpected));

    refresh();
  }, []); // eslint-disable-line

  function refresh() {
    DraNextIndexCustomService.findAll()
      .then((data) => {
        setList(data);
      })
      .catch(() => {
        toast.error(ErrorUnexpected);
      })
      .finally(() => setIsLoading(false));
  }

  function handleSave(data) {
    setIsLoading(true);

    return DraNextIndexCustomService.save(data)
      .then(() => {
        toast.success(OperationSuccessfully);
        refresh();
      })
      .catch((error) => {
        if (!error || !error.response || !error.response.data) {
          toast.error(ErrorUnexpected);
        } else if (error.response.data.title) {
          toast.error(error.response.data.title);
        } else {
          toast.error(ErrorUnexpected);
        }

        return Promise.reject();
      })
      .finally(() => setIsLoading(false));
  }

  function handleDelete(id) {
    Swal.fire({
      icon: "warning",
      title: "Confirmation",
      text: "Are you sure you want to delete?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      closeOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        DraNextIndexCustomService.deleteById(id)
          .then(() => {
            DraNextIndexCustomService.findAll()
              .then((list) => {
                setList(list);
                toast.success(OperationSuccessfully);
              })
              .catch(() => {
                toast.error(ErrorUnexpected);
              });
          })
          .catch(() => {
            toast.error(ErrorUnexpected);
          });
      }
    });
  }

  const columns = [
    {
      title: "Next Index",
      field: "nextIndex",
      type: "numeric",
      cellStyle: {
        textAlign: "left", // For aligning text to the left
      },
      headerStyle: {
        textAlign: "left", // Align header to the left as well
        direction: "rtl",
      },
      validate: (rowData) =>
        rowData.nextIndex ? true : "Next Index is required",
    },
    {
      title: "Tadig",
      field: "plmn.id",
      render: (row) => row.plmn?.name,
      validate: (row) => (row.plmn?.id ? true : "Tadig is required"),
      lookup: plmnList,
      editComponent: ({ value, onChange }) => (
        <Select
          className="flex-1"
          styles={{
            placeholder: (defaultStyle) => {
              return { ...defaultStyle, color: "#495057" };
            },
          }}
          placeholder="-- Select Option --"
          options={Object.keys(plmnList).map((key) => ({
            value: key,
            label: plmnList[key],
          }))}
          value={Object.keys(plmnList)
            .map((key) => ({
              value: key,
              label: plmnList[key],
            }))
            .find((hub) => hub.value === value)}
          onChange={(item) => onChange(item.value)}
          style={{ width: "100%" }} // Aumenta o tamanho do Select
        />
      ),
    },
  ];

  return (
    <Row>
      <Col>
        <div className="ibox">
          <div className=" d-flex justify-content-between align-items-center">
            <h5>Custom</h5>
          </div>
          <div className="ibox-content">
            <MaterialTable
              title=""
              columns={columns}
              data={list}
              isLoading={isLoading}
              editable={{
                onRowAdd: (newData) => handleSave(newData),
              }}
              components={{
                Container: (props) => <Paper {...props} elevation={0} />,
              }}
              actions={[
                {
                  icon: () => <FiTrash2 size={16} color="#007bff" />,
                  tooltip: "DELETE",
                  onClick: (event, rowData) => handleDelete(rowData.id),
                },
              ]}
              options={{
                addRowPosition: "first", // A linha de adição aparece no início
                rowStyle: {
                  fontSize: 13,
                  "& .MuiSelect-root": {
                    width: "100%", // Ajuste o tamanho do Select
                  },
                },
                pageSize: 5,
                pageSizeOptions: [5, 10, 15, 20],
                actionsColumnIndex: -1,
                exportButton: false,
                exportAllData: false,
                searchFieldAlignment: "left",
                toolbarButtonAlignment: "right",
                headerStyle: {
                  textTransform: "uppercase",
                },
              }}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
}
